import React, { useEffect, useState } from "react";
import "./testdetails.css";
import { Card, Row, Col } from "antd";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { bgcolor, bordercolor } from "../../../services/bgcolor";

// Register required components
ChartJS.register(
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const Stats = ({ id, stats, maxmMarks, file }) => {
  const [ScoreLabel, setScoreLabel] = useState([]);
  const [ScoreData, setScoreData] = useState([]);
  const [bgColor1, setBgColor1] = useState([]);
  const [borColor1, setBorColor1] = useState([]);
  const [passData, setPassData] = useState([0, 0]);
  const [statData, setStatData] = useState([0, 0, 0, 0, 0, 0]);

  const passLabel = ["Fail", "Pass"];
  const stat = [
    "91% to 100%",
    "81% to 90%",
    "71% to 80%",
    "61% to 70%",
    "50% to 60%",
    "Below 50%",
  ];

  useEffect(() => {
    let p = 0,
      f = 0;
    let p90_100 = 0,
      p80_90 = 0,
      p70_80 = 0,
      p60_70 = 0,
      p50_60 = 0,
      below50 = 0;

    let maxScore = -1;
    const dp = [];
    const labels = [];
    const bg = [];
    const border = [];

    stats.forEach((d) => {
      const percentage = (d.score / maxmMarks) * 100;
      if (percentage >= 91) p90_100++;
      else if (percentage >= 81) p80_90++;
      else if (percentage >= 71) p70_80++;
      else if (percentage >= 61) p60_70++;
      else if (percentage >= 50) p50_60++;
      else below50++;

      if (d.score >= maxmMarks / 2) p++;
      else f++;

      if (d.score > maxScore) maxScore = d.score;
    });

    for (let i = 0; i <= maxScore; i++) {
      dp.push(0);
      labels.push(i);
      bg.push(bgcolor[i]);
      border.push(bordercolor[i]);
    }

    stats.forEach((d) => {
      dp[d.score]++;
    });

    setScoreLabel(labels);
    setScoreData(dp);
    setBgColor1(bg);
    setBorColor1(border);
    setPassData([f, p]);
    setStatData([p90_100, p80_90, p70_80, p60_70, p50_60, below50]);
  }, [stats, maxmMarks]);

  const barData = {
    labels: ScoreLabel,
    datasets: [
      {
        label: "Scores",
        data: ScoreData,
        backgroundColor: bgColor1,
        borderColor: borColor1,
        borderWidth: 1,
      },
    ],
  };

  const doughnutPassFail = {
    labels: passLabel,
    datasets: [
      {
        label: "Pass/Fail",
        data: passData,
        backgroundColor: [bgcolor[0], bgcolor[1]],
        borderColor: [bordercolor[0], bordercolor[1]],
        borderWidth: 1,
      },
    ],
  };

  const doughnutPercentage = {
    labels: stat,
    datasets: [
      {
        label: "Percentage wise category",
        data: statData,
        backgroundColor: bgcolor.slice(0, 6),
        borderColor: bordercolor.slice(0, 6),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div>
      <Card>
        <div className="download-section">
          <b>Download the test result excel sheet.</b>
          <a
            href={file}
            target="_blank"
            rel="noopener noreferrer"
            className="download-xlsx"
          >
            Download
          </a>
        </div>
      </Card>

      <div style={{ marginTop: "10px" }}>
        <Card>
          <div style={{ padding: "10px 10px 0px 10px" }}>
            <b>Score vs No of students.</b>
          </div>
          <div style={{ padding: "10px 10px 0px 10px" }}>
            <Bar data={barData} options={options} />
          </div>
        </Card>
      </div>

      <div style={{ marginTop: "10px" }}>
        <Card>
          <Row>
            <Col span={12}>
              <div style={{ padding: "10px 10px 0px 10px" }}>
                <b>Pass/Fail.</b>
              </div>
              <div style={{ padding: "10px 10px 0px 10px"}}>
                <Doughnut data={doughnutPassFail} options={options} />
              </div>
            </Col>
            <Col span={12}>
              <div style={{ padding: "10px 10px 0px 10px" }}>
                <b>Percentage wise category.</b>
              </div>
              <div style={{ padding: "10px 10px 0px 10px" }}>
                <Doughnut data={doughnutPercentage} options={options} />
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default Stats;
